module.exports = __webpack_public_path__ + "static/media/profile-icon.a62c7b4f.svg";